import { render, staticRenderFns } from "./ClassESAT.vue?vue&type=template&id=0fdf0674&"
import script from "./ClassESAT.vue?vue&type=script&lang=ts&"
export * from "./ClassESAT.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports